// extracted by mini-css-extract-plugin
module.exports = {"mailer":"_3fY8qEHbNdI61IXjgyjU8Y","phoneNumber":"ySmZEPe_qGLGTJYzrkA94","schoolName":"DEngvsWvDBodZWv6MV11B"};